import styles from './PhotoPicker.module.scss';
import { IPhoto } from '../PhotoPickerContainer';
import PhotoPickerItem from './PhotoPickerItem/PhotoPickerItem';

interface IPhotoPickerProps {
  photos: IPhoto[];
  selectedImages: IPhoto[] | IPhoto;
  onImageClick: (image: IPhoto) => void;
  isFetching: boolean;
}

const PhotoPicker = ({
  photos,
  selectedImages,
  onImageClick,
  isFetching,
}: IPhotoPickerProps) => {
  return (
    <ul className={styles.photoPicker}>
      {photos?.map(photo => (
        <PhotoPickerItem
          key={photo.id}
          id={photo.id}
          isSelected={
            Array.isArray(selectedImages)
              ? !!selectedImages?.find(
                  selectedImage => selectedImage.id === photo.id
                )
              : selectedImages.id === photo.id
          }
          image_url={photo.full_photo_url}
          onImageClick={() => onImageClick(photo)}
          isFetching={isFetching}
        />
      ))}
    </ul>
  );
};

export default PhotoPicker;
